import '@angular/compiler';
import { PageInfraComponent } from './page.infra/page.infra.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalTicketingListComponent } from './portal.ticketing.list/portal.ticketing.list.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageTicketsGItemComponent } from './page.tickets.g.item/page.tickets.g.item.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalTicketingCreateComponent } from './portal.ticketing.create/portal.ticketing.create.component';
import { PageTicketsItemComponent } from './page.tickets.item/page.tickets.item.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageTicketsComponent } from './page.tickets/page.tickets.component';
import { PageTicketDesignsComponent } from './page.ticket.designs/page.ticket.designs.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageTicketsCreateComponent } from './page.tickets.create/page.tickets.create.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageTicketsGComponent } from './page.tickets.g/page.tickets.g.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalTicketingDetailComponent } from './portal.ticketing.detail/portal.ticketing.detail.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "infra",
                component: PageInfraComponent,
                "app_id": "page.infra"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "tickets-g/:id/:tab?",
                component: PageTicketsGItemComponent,
                "app_id": "page.tickets.g.item"
            },
            {
                "path": "tickets/:id/:tab?",
                component: PageTicketsItemComponent,
                "app_id": "page.tickets.item"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "tickets",
                component: PageTicketsComponent,
                "app_id": "page.tickets"
            },
            {
                "path": "ticket-designs",
                component: PageTicketDesignsComponent,
                "app_id": "page.ticket.designs"
            },
            {
                "path": "tickets/create",
                component: PageTicketsCreateComponent,
                "app_id": "page.tickets.create"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "tickets-g",
                component: PageTicketsGComponent,
                "app_id": "page.tickets.g"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }